import { Component, OnInit, Inject, Renderer2, OnDestroy } from '@angular/core';
import { Router, Data, ActivatedRoute } from "@angular/router";
import { AuthenticationService } from "@services/authentication.service";
import { first, debounce } from 'rxjs/operators';

import { CommonService } from '@services/app.common.service';
import { HttpClient } from '@angular/common/http';
import { StatusCode } from '../_shared/_enums/Common';
import { FormConfigModel } from '../_shared/_models/Layout/FormConfig';


@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgotPassword.component.html',
    styleUrls: ['./forgotPassword.component.css'],
    standalone: false
})
export class ForgotPasswordComponent implements OnInit {
  user = {
    userName: '',
    password: ''
  };
  public modalConfig = {} as FormConfigModel;
  public error: string = '';
  public showLoader: boolean = false;
  data = [];
  public _http;
  public _baseUrl;
  public StatusCode = StatusCode;
  public tokenResponse: any;


  constructor(private router: Router, private route: ActivatedRoute, public common: CommonService, public authService: AuthenticationService, http: HttpClient, @Inject('BASE_URL') baseUrl: string, private renderer: Renderer2) {
    this.user = {
      userName: '',
      password: ''
    };

    this._http = http;
    this._baseUrl = baseUrl;

    this.renderer.removeClass(document.body, 'body-class');
    this.renderer.addClass(document.body, 'body-class-login');
  }

  ngOnInit() {

    this.modalConfig.hideDefaultAction = true;
    this.modalConfig.hideCard = false;
    this.route.data.subscribe((data: Data) => {
      this.tokenResponse = data['tokenResponse'];
    });


  }


  getTranslationFile() {
    this.common.PostData('Translation/GetTranslationFile', navigator.language).then(data => {
      this.data = data;
    });
  }

  forgotPassword() {

    let userName = this.user.userName;
    this.common.Loader.show();
    let $this = this;
    this.common.SetAccessToken(this.tokenResponse.resultData);

    this.common.GetData(this.common.ApiUrls.ForgotPassword.ForgotPassword + this.user.userName, true).then(function (data) {
      if (data.status == StatusCode.OK) {
        $this.error = $this.common.GetTranslation('Messages.EmailSent');
        $this.common.Loader.hide();
        $this.common.RemoveAccessToken();
      } else {
        $this.error = $this.common.GetTranslation('Messages.EmailSent');
        $this.common.RemoveAccessToken();
        $this.common.Loader.hide();
      }
    });
  }
}


